module.exports = __webpack_public_path__ + "01f43047/img/saly-icon.39e12342.jpg";